import { Mark } from 'tiptap';
import {
	markInputRule,
	updateMark,
	// removeMark,
} from 'tiptap-commands';

/**
 * Color - Extends the built in Mark from tiptap allowing
 * the editor to <drumroll> set the font-size.
 */
export default class Color extends Mark {
	// eslint-disable-next-line class-methods-use-this
	get name() {
		return 'color';
	}

	// eslint-disable-next-line class-methods-use-this
	get schema() {
		return {
			attrs: {
				color: {
					default: '#000',
				},
			},
			parseDOM: [
				{
					style: 'color',
					// getAttrs: value => value.indexOf('em') !== -1 ? {fontSize:value} : '',
					getAttrs: value => ({ color: value }),
				},
			],
			toDOM: mark => ['span', { style: `color: ${mark.attrs.color}` }, 0],
		};
	}

	// eslint-disable-next-line class-methods-use-this
	commands({ type }) {
		return attrs => updateMark(type, attrs);
	}

	// eslint-disable-next-line class-methods-use-this
	inputRules({ type }) {
		return [
			markInputRule(/(?:\*\*|__)([^*_]+)(?:\*\*|__)$/, type),
		];
	}
}
